// extracted by mini-css-extract-plugin
export var active = "_9w-a";
export var activeIndicator = "_9w-9";
export var disabled = "_9w-b";
export var fullWidth = "_9w-2";
export var lg = "_9w-7";
export var md = "_9w-6";
export var redoButtonTabGroup = "_9w-0";
export var sm = "_9w-5";
export var tabButton = "_9w-4";
export var tabButtonsContainer = "_9w-1";
export var themeDestructive = "_9w-d";
export var themeNormal = "_9w-c";
export var themeSuccess = "_9w-e";
export var xl = "_9w-8";
export var xs = "_9w-3";